import ProductHero from './ProductHero.jsx';
import ProductProblem from './ProductProblem.jsx';
import ProductFeatures from './ProductFeatures.jsx';
import ProductBuyer from './ProductBuyer.jsx';
import ProductOutcomes from './ProductOutcomes.jsx';
import ProductCTABand from './ProductCTABand.jsx';

/* <ProductDeepDive />
   ----------------------------------------------------------
   One "world" per product: hero, problem, features, ideal
   buyer, outcomes, and per-product CTA. The card's accent
   color is set via the inline custom property --product-accent
   so feature index labels and outcome metrics pick it up
   automatically. Each product gets its own section on the
   landing page so visitors can read Theo and OpenCharts in
   order without tabs or a rail. */
export default function ProductDeepDive({ product }) {
  return (
    <div
      id={`product-${product.id}`}
      className="product-deep-dive"
      style={{ '--product-accent': product.accent }}
    >
      <ProductHero product={product} />
      <ProductProblem product={product} />
      <ProductFeatures product={product} />
      <ProductBuyer product={product} />
      <ProductOutcomes product={product} />
      <ProductCTABand product={product} />
    </div>
  );
}
